import React from "react";
import { Table } from "react-bootstrap";

import { useTournamentRegistrationsContext } from "../contexts/TournamentRegistrations";
import useTableHandler from "../hooks/useTableHandler";

const RegistrationsTable = (): React.JSX.Element => {
    const { orders, filters } = useTournamentRegistrationsContext();
    const { generateTableRow } = useTableHandler();

    return (
        <Table
            className="tournamentRegistrationsTable mt-2"
            data-testid="tournamentRegistrationsTable"
            striped
            bordered
            responsive
        >
            <thead>
                <tr>
                    <th>Order Id</th>
                    <th>Date</th>
                    <th>Status</th>
                    <th>Paid Date</th>
                    <th>Tournament</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Team Name</th>
                    <th>Age Level</th>
                    <th>Friday Ok?</th>
                    <th>Amount</th>
                    <th>Payment Type</th>
                    <th>Notes?</th>
                    <th>View</th>
                </tr>
            </thead>
            <tbody>
                {orders.map(o =>
                    o.products
                        .filter(p =>
                            filters.ageLevels.filter
                                ? filters.ageLevels.filter?.includes(p.name)
                                : true,
                        )
                        .filter(p =>
                            filters.search
                                ? (p.meta.teamName
                                      ? p.meta.teamName
                                            .toLowerCase()
                                            .includes(
                                                filters.search.toLowerCase(),
                                            )
                                      : false) ||
                                  p.description
                                      .toLowerCase()
                                      .includes(filters.search.toLowerCase()) ||
                                  o.user.email
                                      .toLowerCase()
                                      .includes(filters.search.toLowerCase()) ||
                                  o.user.name
                                      .toLowerCase()
                                      .includes(filters.search.toLowerCase())
                                : true,
                        )
                        .map(
                            (p, idx) =>
                                p.status !== "cancelled" &&
                                generateTableRow(o, p, idx),
                        ),
                )}
            </tbody>
        </Table>
    );
};

export default RegistrationsTable;
